<!--
Created on 2021-04-17
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-17
-->
<template>
  <div>login</div>
</template>

<script>
export default {
  name: 'Login',
  setup() {
    return {
    }
  },
}
</script>
